import { Search } from '@mui/icons-material';
import React, { useEffect } from 'react';
import "./Widget.css";

function Widgets() {
  useEffect(() => {
    // 既存のスクリプトを削除（必要な場合）
    const existingScript = document.getElementById('twitter-widget');
    if (existingScript) {
      existingScript.remove();
    }

    // Xのウィジェットスクリプトを動的に読み込む
    const script = document.createElement('script');
    script.id = 'twitter-widget'; // IDを追加
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    
    // スクリプト読み込み後にウィジェットを初期化
    script.onload = () => {
      if (window.twttr) {
        window.twttr.widgets.load();
      }
    };

    document.body.appendChild(script);

    return () => {
      // クリーンアップ時の処理
      const scriptToRemove = document.getElementById('twitter-widget');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <div className='widgets'>
      <div className='widgets_input'>
        <Search className='widgets_searchIcon' />
        <input placeholder='キーワード検索' type='text'/>
      </div>
      <div className='widgets_widgetContainer'>
        <div className="widgets_content">
          <h2>いまどうしてる？</h2>
          
          {/* 個別のツイート埋め込み */}
          <div className="widget-item">
            <blockquote className="twitter-tweet">
              <a href="https://twitter.com/user/status/1716358192198975961"></a>
            </blockquote>
          </div>

          {/* タイムライン埋め込み */}
          <div className="widget-item">
            <a className="twitter-timeline" 
               data-height="400" 
               href="https://twitter.com/ariyoshihiroiki">
            </a>
          </div>

          {/* シェアボタン */}
          <div className="widget-item">
            <a href="https://twitter.com/share" 
               className="twitter-share-button" 
               data-text="#React.js勉強中" 
               data-via="ariyoshihiroiki">
              Tweet
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Widgets;
